export default "<ng-container *ngTemplateOutlet=\"itemTemplate; context:itemContext\"></ng-container>\n"